import { render, staticRenderFns } from "./ArtificialPaperFilter.vue?vue&type=template&id=394a8514&scoped=true"
import script from "./ArtificialPaperFilter.vue?vue&type=script&lang=js"
export * from "./ArtificialPaperFilter.vue?vue&type=script&lang=js"
import style0 from "./ArtificialPaperFilter.vue?vue&type=style&index=0&id=394a8514&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394a8514",
  null
  
)

export default component.exports